export default __webpack_public_path__ + "static/media/logo.e7d5d499.webp";